/**
 * im上传附件
 * Bai.Zhiming
 * 2019-7-22
 */
angular.module('imUploadFileModule', []).
directive("imUploadFile", ['$q', 'modalDialog', 'dialogBoxService', '$timeout', function($q, modalDialog, dialogBoxService, $timeout) {
    return {
        restrict: "A",
        replace: false,
        scope: {
            fn: '=',
            loaders: '='
        },
        link(scope, $element, $attrs) {
            initStatus();
            initData();
            /**
             * [initClick description] 初始化点击上传事件
             * @return {[type]} [description]
             */
            function initClick() {
                $element.click(() => {
                    scope.status.$fileInput[0].click();
                });
            }
            /**
             * [createFileInput description] 创建一个文件选择器
             * @return {[type]} [description]
             */
            function createFileInput() {
                scope.status.$fileInput = $(document.createElement('input'));
                scope.status.$fileInput.attr({
                    type: 'file',
                    accept: $attrs.accept,
                    multiple: true,
                });
                scope.status.$fileInput.change((event) => {
                    if (event.target.files.length == 0) return;
                    let loaders = dialogBoxService.uploadImages(event.target.files,$attrs['toAccount'], Number($attrs['businessType'])).then(resp => {
                        event.target.value = "";
                        if (scope.fn && angular.isFunction(scope.fn.getImages)) {
                            scope.fn.getImages(resp);
                        }
                    });
                    $timeout(() => {
                        scope.loaders = loaders;
                    });
                });
            }
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {};
                scope.data = {};
                createFileInput();
                initClick();
            }
            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {}
        }
    };
}]);